import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { ColumnItem } from '../column-item';
export function Spacer(_a) {
    var containerBackgroundColor = _a.containerBackgroundColor, cssClass = _a.cssClass, _b = _a.height, height = _b === void 0 ? '20px' : _b;
    return (React.createElement(ColumnItem, { cssClass: cssClass, containerBackgroundColor: containerBackgroundColor },
        React.createElement(SecureHtml, { containerProps: { style: { height: height, lineHeight: height } }, html: '&#8202;', skipCleaning: true })));
}
//# sourceMappingURL=spacer.js.map